import axios from "axios"
import { APIURL } from "../Constantes"
import { getCabecera } from "../utils/getCabecera"
import { getError } from "../utils/errors"

const urlBank = "Bank"
/**
 * *Metodos para administra los bancos
 */
//* Consulta bancos cotizador
export const getBancosListadoCotizador = async () => {
    return axios.get(`${APIURL}/${urlBank}/Quotation`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            return [];
        })
}
export const getBancosListado = async () => {
    return axios.get(`${APIURL}/${urlBank}/Available`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            return [];
        })
}
export const getBancos = async () => {
    return axios.get(`${APIURL}/${urlBank}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            return [];
        })
}
export const newBanco = async ({ Nombre, TasaCobro }) => {
    return axios.post(`${APIURL}/${urlBank}`,
        {
            Nombre,
            TasaCobro
        },
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            return getError(Error);
        })
}
export const deleteBanco = async ({ idBanco }) => {
    return axios.delete(`${APIURL}/${urlBank}/${idBanco}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            return getError(Error);
        })
}
export const updateBanco = async ({ idBanco, Nombre, TasaCobro, Estatus }) => {
    return axios.put(`${APIURL}/${urlBank}/${idBanco}`,
        {
            Nombre,
            TasaCobro,
            Estatus
        },
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            return getError(Error);
        })
}
/**
 * *Metodos para administra las mensualidades
 */
export const getCatMensualidades = async () => {
    return axios.get(`${APIURL}/${urlBank}/Monthly/Number`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            return [];
        })
}
export const newCatMensulidades = async ({ Cantidad }) => {
    return axios.post(`${APIURL}/${urlBank}/Monthly/Number`,
        {
            Cantidad
        },
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            return getError(Error);
        })
}
export const deleteCatMensualidad = async ({ IdMensualidad }) => {
    return axios.delete(`${APIURL}/${urlBank}/Monthly/Number/${IdMensualidad}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            return getError(Error);
        })
}
export const updateCatMensualidad = async ({ IdMensualidad, Cantidad, Estatus }) => {
    return axios.put(`${APIURL}/${urlBank}/Monthly/Number/${IdMensualidad}`,
        {
            Cantidad,
            Estatus,
        },
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            return getError(Error);
        })
}
//* Metodos para adminstrar las mensualidades de los bancos
export const getMensualidadesBanco = async ({ IdBanco }) => {
    return axios.get(`${APIURL}/${urlBank}/Monthly/${IdBanco}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            return [];
        })
}
export const newMensulidadesBanco = async ({ IdBanco, IdMensualidad, SobreTasa }) => {
    return axios.post(`${APIURL}/${urlBank}/Monthly`,
        {
            IdBanco,
            IdMensualidad,
            SobreTasa
        },
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            return getError(Error);
        })
}
export const deleteMensualidadBanco = async ({ IdBancoMensualidad }) => {
    return axios.delete(`${APIURL}/${urlBank}/Monthly/${IdBancoMensualidad}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            return getError(Error);
        })
}
export const putMensulidadesBanco = async ({ IdBancoMensualidad, IdBanco, IdMensualidad, SobreTasa }) => {
    return axios.put(`${APIURL}/${urlBank}/Monthly/${IdBancoMensualidad}`,
        {
            IdBanco,
            IdMensualidad,
            SobreTasa
        },
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            return getError(Error);
        })
}
//* Metodo para obtener el el catoalo de bancos para cotizador
export const getBancoGeneralAll = async () => {
    return axios.get(`${APIURL}/${urlBank}/General`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            return [];
        })
}
export const getBancoGeneral = async ({ IdBancoGeneral }) => {
    return axios.get(`${APIURL}/${urlBank}/General/${IdBancoGeneral}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            return [];
        })
}
export const newBancoGeneral = async ({ Nombre, TasaGeneral }) => {
    return axios.post(`${APIURL}/${urlBank}/General`,
        {
            Nombre,
            TasaGeneral
        },
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            return getError(Error);
        })
}
export const deleteBancoGeneral = async ({ IdBancoGeneral }) => {
    return axios.delete(`${APIURL}/${urlBank}/General/${IdBancoGeneral}`,
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            return getError(Error);
        })
}
export const updateBancoGeneral = async ({ IdBancoGeneral, Nombre, TasaGeneral }) => {
    return axios.put(`${APIURL}/${urlBank}/General/${IdBancoGeneral}`,
        {
            Nombre,
            TasaGeneral,
        },
        {
            headers: getCabecera()
        }).then((Response) => {
            return Response.data;
        }).catch((Error) => {
            return getError(Error);
        })
}